import React, { Component } from 'react';
import $ from 'jquery';

import AdminLayout from './layout';

import FetchCall from '../../API/FetchCall';

import { getSchoolDetail } from '../../API/FetchCall';
//import { Editor } from '@tinymce/tinymce-react';
import { Modal, ModalBody, Row, Col, ModalFooter } from 'reactstrap';

class verticalCampsDetail extends Component {

      constructor(props) {
        super(props);
        this.state = {
            infoDetails: [],
        };
        this.id = this.props.match.params.id;
        this.type = this.props.match.params.type;
        this.infoDetails = this.infoDetails.bind(this);


    }

    componentDidMount() {
        console.log(this.props);
        this.infoDetails();
    }

    getPageTitle(title) {
        let activityTitle = '';
        switch (title) {
            case "tution":
                activityTitle = 'Tution Info';
                break;

            case "music":
                activityTitle = 'Music Info';
                break;

            case "sports":
                activityTitle = 'Sports Info';
                break;

            case "dance":
                activityTitle = 'Dance Info';
                break;

            case "drawing":
                activityTitle = 'Drawing Info';
                break;
            case "yoga":
                activityTitle = 'Yoga Info';
                break;

            default:
                activityTitle = title;
        }
        return activityTitle;
    }

    UNSAFE_componentWillMount() {

    }

    componentDidUpdate() {
    }

    async infoDetails() {
        let response = await FetchCall.getCampInfo(this.id);
        if (response) {
            const data = response.data;
            this.setState({
                infoDetails: data,
                url: data.url,
                photos_arr: data.photo_arr,
            });

        } else {
            return <div>Error</div>;
        }
    }

    gallery_image() {

        let photos = this.state.photos_arr !== undefined ? this.state.photos_arr : [];
        let rows = "";
        if (photos.length > 0) {
            rows = photos.map((photos, index) => {
                if (photos.name)
                    return (
                        <div class="col-md-4 float-left mt-4 p-0">
                            <img src={this.state.url + photos.name} alt="Img" class="img-thumbnail" />
                        </div>
                    );
            });
        } else {
            rows = "";
        }
        return rows;

    }


    render() {

        const { infoDetails } = this.state;
        console.log('infoDetails', this.state);
        console.log('activityTitle', this.state.activityTitle);

        let type = '';
        switch (infoDetails.invities) {
            case "0_to_3":
                type = '0 to 3 Yrs'; break;
            case "4_to_8":
                type = '4 to 8 Yrs'; break;
            case "9_to_12":
                type = '9 to 12 Yrs'; break;
            case "13_to_15":
                type = '13 to 15 Yrs'; break;
            default:
                type = infoDetails.invities;
        }
        let stdRa = '';
        if (infoDetails.student_ratio == 1) {
            stdRa = 'One to One';
        } else if (infoDetails.student_ratio == 2) {
            stdRa = 'One to Many';
        }


        return (
            <React.Fragment>
                <AdminLayout>
                    
           <div class="col-lg-12 grid-margin stretch-card">
              <div class="card">
                <div class="card-body">
                  <h4 class="card-title">{infoDetails.camp_name} - View</h4>
                                   
                  <div class="pt-3 detailsection">
                        
                   <div id="company-info" className="tab-pane active">

                                            <div className="box-shadow-custom">
                                                <div className="row">
                                                    <div className="form-group col-md-4">
                                                        <label>Registration No.</label>
                                                        <p>{infoDetails.registration_no}</p>
                                                    </div>
                                                    <div className="form-group col-md-4">
                                                        <label>Camp Name </label>
                                                        <p>{infoDetails.camp_name}</p>
                                                    </div>
                                                    <div className="form-group col-md-4">
                                                        <label>Invitees</label>
                                                        <p>{infoDetails.invities}</p>
                                                    </div>
                                                    <div className="form-group col-md-4">
                                                        <label>sub type</label>
                                                        <p>{infoDetails.subtype}</p>
                                                    </div>

                                                </div>
                                            </div>

                                            <div className="box-shadow-custom">
                                                <div className="row">
                                                    <div className="col-md-12 col-xs-12">
                                                        <span className="form-legend">Key Information</span>
                                                    </div>
                                                    <div className="form-group col-md-4">
                                                        <label>Contact Person</label>
                                                        <p>{infoDetails.contact_person}</p>
                                                    </div>
                                                    <div className="form-group col-md-4">
                                                        <label>Contact No.</label>
                                                        <p>{infoDetails.phone_number}</p>
                                                    </div>

                                                    <div className="form-group col-md-4">
                                                        <label>Email Id</label>
                                                        <p>{infoDetails.email_id}</p>
                                                    </div>
                                                    <div className="form-group col-md-4">
                                                        <label>Type</label>
                                                        <p>{infoDetails.tution_type}</p>
                                                    </div>
                                                    <div className="form-group col-md-4">
                                                        <label>Student Ratio</label>
                                                        <p>{infoDetails.student_ratio}</p>
                                                    </div>
                                                    <div className="form-group col-md-4">
                                                        <label>Website</label>
                                                        <p>{infoDetails.website}</p>
                                                    </div>
                                                    <div className="form-group col-md-4">
                                                        <label>Facebook</label>
                                                        <p>{infoDetails.facebook}</p>
                                                    </div>
                                                    <div className="form-group col-md-4">
                                                        <label>Twitter</label>
                                                        <p>{infoDetails.twitter}</p>
                                                    </div>

                                                    <div className="form-group col-md-4">
                                                        <label>Fee - based on activity </label>
                                                        <p>{infoDetails.event_fee}</p>
                                                    </div>

                                                    <div className="form-group col-md-4">
                                                        <label>When </label>
                                                        <p>{infoDetails.when}</p>
                                                    </div>

                                                    <div className="form-group col-md-4">
                                                        <label>Registration Info</label>
                                                        <p>{infoDetails.registeration}</p>
                                                    </div>

                                                    <div className="form-group col-md-4">
                                                        <label>Website Search Keywords</label>
                                                        <p>{infoDetails.keywords}</p>
                                                    </div>
                                                    <div className="form-group col-md-4">
                                                        <label>Where </label>
                                                        <p>{infoDetails.where}</p>
                                                    </div>
                                                    <div className="form-group col-md-4">
                                                        <label>Google Location </label>
                                                        <p>{infoDetails.google_location}</p>
                                                    </div>
                                                    {(infoDetails.vendor_id == 1 && (
                                                        <div className="form-group col-md-4">
                                                            <label>Partner Type</label>
                                                            <p>{infoDetails.partner_type == 1 ? 'Institution' : 'Individual'}</p>
                                                        </div>
                                                    ))}
                                                    <div className="form-group col-md-12">
                                                        <label>About</label>
                                                        <p>{infoDetails.about_camp}</p>
                                                    </div>
                                                </div>
                                            </div>


                                            <div className="box-shadow-custom">
                                                <div className="row">
                                                    <div className="col-md-12 col-xs-12">
                                                        <span className="form-legend">Images</span>
                                                    </div>
                                                    <div className="form-group col-md-4">
                                                        <label>Banner </label>
                                                        {infoDetails.images &&
                                                            <img src={infoDetails.url + infoDetails.images} alt="Img" class="img-thumbnail" />
                                                        }
                                                    </div>



                                                    <div class="col-md-12 float-left mt-4 p-0">
                                                        <label>
                                                            Gallery Images
                                                        </label>
                                                    </div>
                                                    {this.gallery_image()}

                                                </div>
                                            </div>

                                        </div>
               
                  </div>
                </div>
              </div>
            </div>

                </AdminLayout>
            </React.Fragment>
        )
    }
}


export default verticalCampsDetail;


// WEBPACK FOOTER //
// ./src/components/bewise/verticalCampsDetail.jsx